module.exports = __webpack_public_path__ + "static/media/round-library-books-24-px.88959ac0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/round-library-books-24-px.svg
// module id = 770
// module chunks = 0